import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageShell from '../components/LegalPageShell';
import LEGAL_DETAILS from '../config/legal';
import SEO from '../components/SEO';
import { SEO_TEXTES } from '../data/seoTextes';

const introPoints = [
  'Cette application permet aux utilisateurs autoris\u00e9s de se connecter aux services, portails et outils en ligne propos\u00e9s par METERIS.',
  "L'authentification Google est utilis\u00e9e uniquement pour simplifier et s\u00e9curiser la connexion.",
  "Les donn\u00e9es demand\u00e9es sont limit\u00e9es au strict n\u00e9cessaire pour v\u00e9rifier l'identit\u00e9 de l'utilisateur et autoriser l'acc\u00e8s \u00e0 son compte.",
];

const scopePoints = [
  'Acc\u00e8s r\u00e9serv\u00e9 aux utilisateurs habilit\u00e9s.',
  "Utilisation destin\u00e9e \u00e0 la connexion et \u00e0 la gestion des acc\u00e8s METERIS.",
  'Aucune fonctionnalit\u00e9 marketing ou publicitaire li\u00e9e \u00e0 la connexion Google.',
];

const supportDetails = [
  { label: 'Nom', value: LEGAL_DETAILS.companyName },
  { label: 'Email', value: LEGAL_DETAILS.contactEmail },
  { label: 'Site web', value: LEGAL_DETAILS.website },
];

const legalLinks = [
  { label: 'Politique de confidentialité', to: '/politique-confidentialite' },
  { label: "Mentions légales et conditions d'utilisation", to: '/mentions-legales' },
];

function DetailList({ items }) {
  return (
    <dl className="space-y-4">
      {items.map((item) => (
        <div key={item.label} className="border-b border-white/5 pb-4 last:border-b-0 last:pb-0">
          <dt className="text-sm uppercase tracking-[0.18em] text-slate-500 mb-1">{item.label}</dt>
          <dd className="text-base text-slate-200">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}

function BulletList({ items }) {
  return (
    <ul className="space-y-3">
      {items.map((item) => (
        <li key={item} className="flex gap-3 text-slate-300 leading-relaxed">
          <span className="mt-2 h-2 w-2 rounded-full bg-[#0099D6] flex-shrink-0" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

export default function GoogleAppsPage() {
  return (
    <>
      <SEO {...SEO_TEXTES['/google-app']} path="/google-app" />
    <LegalPageShell
      testId="google-apps-page"
      title="METERIS"
      subtitle={'Connexion s\u00e9curis\u00e9e aux services METERIS'}
    >
      <div className="grid gap-6 lg:grid-cols-[minmax(0,1.6fr)_minmax(280px,0.9fr)]">
        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-5">{'Pr\u00e9sentation'}</h2>
          <BulletList items={introPoints} />
        </section>

        <aside className="rounded-3xl border border-white/5 bg-[#0F1117]/90 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-5">Support</h2>
          <DetailList items={supportDetails} />
        </aside>
      </div>

      <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
        <h2 className="text-2xl font-semibold text-white mb-5">{'Cadre d\'utilisation'}</h2>
        <BulletList items={scopePoints} />
      </section>

      <section className="rounded-3xl border border-white/5 bg-[#0F1117]/90 p-8 md:p-10">
        <h2 className="text-2xl font-semibold text-white mb-5">Informations légales</h2>
        <p className="text-slate-300 leading-relaxed mb-6">
          {'Pour consulter les informations relatives à la confidentialité et aux conditions d\'utilisation de l\'application, accédez directement aux pages suivantes :'}
        </p>
        <div className="flex flex-col gap-3">
          {legalLinks.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="inline-flex w-fit items-center rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-sm font-medium text-slate-200 transition-colors hover:border-[#0099D6]/40 hover:text-white"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </section>
    </LegalPageShell>
    </>
  );
}
